module.exports = __webpack_public_path__ + "static/media/reset.ff2aac83.svg";